import { z } from 'zod';
/**
 * Login Request Schema
 */
export const loginSchema = z.object({
    email: z.string().email('Ongeldig e-mailadres'),
    password: z.string().min(1, 'Wachtwoord is verplicht'),
});
/**
 * Refresh Token Request Schema
 */
export const refreshTokenSchema = z.object({
    refreshToken: z.string().min(1, 'Refresh token is verplicht'),
});
// Alias for backward compatibility
export const refreshSchema = refreshTokenSchema;
/**
 * User Response Schema (for validation)
 */
export const userResponseSchema = z.object({
    id: z.number(),
    email: z.string().email(),
    name: z.string(),
    role: z.enum(['admin', 'hr', 'beoordelaar', 'medewerker']),
});
/**
 * Login Response Schema (for validation)
 */
export const loginResponseSchema = z.object({
    user: userResponseSchema,
    accessToken: z.string(),
    refreshToken: z.string(),
});
/**
 * Token Refresh Response Schema (for validation)
 */
export const refreshResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
});
/**
 * API Error Response Schema (for validation)
 */
export const apiErrorSchema = z.object({
    error: z.string(),
    code: z.string(),
    details: z.any().optional(),
});
//# sourceMappingURL=auth.js.map